// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { manta as _manta } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the manta chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 169
 * Chain Name: Manta Pacific Mainnet
 * Default Block Explorer: https://pacific-explorer.manta.network
 * Default RPC URL: https://pacific-rpc.manta.network/http
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { manta } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: manta,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const manta = createCommon({
	..._manta,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
